var _style, _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 627",
    style: {
      enableBackground: "new 0 0 1200 627"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000172433595347497259170000014473519284538820754_);fill:none;}\n\t.st1{clip-path:url(#SVGID_00000172433595347497259170000014473519284538820754_);fill:#13033C;}\n\t\n\t\t.st2{opacity:0.2;clip-path:url(#SVGID_00000172433595347497259170000014473519284538820754_);fill:url(#SVGID_00000034050381654738608930000011672877002221518720_);enable-background:new    ;}\n\t\n\t\t.st3{opacity:0.2;clip-path:url(#SVGID_00000172433595347497259170000014473519284538820754_);fill:url(#SVGID_00000044873420641416067660000013313791403441808295_);enable-background:new    ;}\n\t\n\t\t.st4{opacity:0.2;clip-path:url(#SVGID_00000172433595347497259170000014473519284538820754_);fill:url(#SVGID_00000117654483106959280750000005004379454906300823_);enable-background:new    ;}\n\t\n\t\t.st5{opacity:0.15;clip-path:url(#SVGID_00000172433595347497259170000014473519284538820754_);fill:url(#SVGID_00000031895723544548771560000007063170522666210443_);enable-background:new    ;}\n\t\n\t\t.st6{opacity:0.1;clip-path:url(#SVGID_00000172433595347497259170000014473519284538820754_);fill:url(#SVGID_00000116195687013304693070000005199432023937713834_);enable-background:new    ;}\n\t.st7{opacity:0.8;clip-path:url(#SVGID_00000172433595347497259170000014473519284538820754_);}\n\t.st8{fill:#F02076;}\n\t.st9{opacity:0.3;clip-path:url(#SVGID_00000172433595347497259170000014473519284538820754_);}\n\t.st10{fill:#130632;}\n\t\n\t\t.st11{opacity:5.000000e-02;clip-path:url(#SVGID_00000172433595347497259170000014473519284538820754_);fill:#F02076;enable-background:new    ;}\n\t\n\t\t.st12{opacity:0.1;clip-path:url(#SVGID_00000172433595347497259170000014473519284538820754_);fill:#F02076;enable-background:new    ;}\n\t\n\t\t.st13{opacity:0.4;clip-path:url(#SVGID_00000172433595347497259170000014473519284538820754_);fill:#F02076;enable-background:new    ;}\n\t.st14{opacity:0.6;clip-path:url(#SVGID_00000172433595347497259170000014473519284538820754_);}\n\t.st15{fill:#5125C2;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -18.8,
    y: -7.1,
    width: 1233,
    height: 655
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047749061804726114370000003465041225202563747_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: -1596.6,
    y: 596.3,
    style: {
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)",
      fill: "none"
    },
    width: 1672,
    height: 836
  }), /*#__PURE__*/React.createElement("rect", {
    x: -18.8,
    y: -7.1,
    style: {
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)",
      fill: "#13033C"
    },
    width: 1233,
    height: 655
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167359523254739509770000008851764998074720665_",
    gradientUnits: "userSpaceOnUse",
    x1: 1368.1978,
    y1: 1362.5177,
    x2: 1704.4269,
    y2: 1075.994,
    gradientTransform: "matrix(-0.8476 0.1146 0.1383 1.023 2345.1306 -1433.8835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B835D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4743,
    style: {
      stopColor: "#F62381"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC751"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)",
      fill: "url(#SVGID_00000167359523254739509770000008851764998074720665_)",
      enableBackground: "new"
    },
    d: " M1173.8,232.3c-36.8-13.1-89.2-74.6-110.3-108.3c-36.2-57.7-60-128.4-40.2-191.3c18.9-60.1,72.2-101.8,125.9-123.8 c15.1-6.2,31.2-11.5,47.3-14.9c42.8-9.1,92.1-24.3,133.5,10.4c52.5,44,75,172.8,26.5,213c-26.8,22.2-37.9,15.9-62.8,40.6 c-55.1,54.5-1.3,142.4-59.9,173.9C1222.1,238.1,1210.6,245.4,1173.8,232.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108989936114860468470000008918592607114074512_",
    gradientUnits: "userSpaceOnUse",
    x1: 1305.7524,
    y1: 2489.5674,
    x2: 1694.6622,
    y2: 2158.1511,
    gradientTransform: "matrix(0.1058 0.9451 1.0259 -0.1148 -2444.4939 -637.5262)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B835D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4743,
    style: {
      stopColor: "#F62381"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC751"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)",
      fill: "url(#SVGID_00000108989936114860468470000008918592607114074512_)",
      enableBackground: "new"
    },
    d: " M378.9,572.6c-15.7,46.6-87.5,111.2-126.8,136.9c-67.3,43.9-149.5,71.4-222,43.3c-69.3-26.9-117-97.2-141.9-167 c-7-19.7-12.9-40.5-16.7-61.4c-10-55.3-27.1-119.3,13.7-170.9c51.7-65.5,201.1-88.7,247-24.7c25.4,35.4,18,49.4,46.2,82.4 c62.4,73.1,165,8,200.7,84.5C386.3,510.9,394.6,526,378.9,572.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142170546784692957330000000227861107735811712_",
    gradientUnits: "userSpaceOnUse",
    x1: 1529.337,
    y1: 3467.6213,
    x2: 1918.2468,
    y2: 3136.2048,
    gradientTransform: "matrix(0.1058 0.9451 1.0259 -0.1148 -2444.4939 -637.5262)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B835D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4743,
    style: {
      stopColor: "#F62381"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC751"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)",
      fill: "url(#SVGID_00000142170546784692957330000000227861107735811712_)",
      enableBackground: "new"
    },
    d: " M1405.9,671.6c-15.7,46.6-87.5,111.2-126.8,136.9c-67.3,43.9-149.5,71.4-222,43.3c-69.3-26.9-117-97.2-141.9-167 c-7-19.7-12.9-40.5-16.7-61.4c-10-55.3-27.1-119.3,13.7-170.9c51.7-65.5,201.1-88.7,247-24.7c25.4,35.4,18,49.4,46.2,82.4 c62.4,73.1,165,8,200.7,84.5C1413.3,609.9,1421.6,625,1405.9,671.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027583184108161538830000013480250251645934487_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.6631,
    y1: 630.9664,
    x2: -275.2195,
    y2: 582.6619,
    gradientTransform: "matrix(1 0 0 -1 0 627)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B835D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7834,
    style: {
      stopColor: "#FF6447"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC751"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)",
      fill: "url(#SVGID_00000027583184108161538830000013480250251645934487_)",
      enableBackground: "new"
    },
    d: " M-79.5-80.5C-58.9-130.5,42-178.9,148-88.2C299.6,41.6,145.9,248.6-0.1,123.7C-102.3,36.2-100-30.4-79.5-80.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057860770220783905070000016252789545087560612_",
    gradientUnits: "userSpaceOnUse",
    x1: 279.0639,
    y1: 194.0981,
    x2: -239.2624,
    y2: -122.3668,
    gradientTransform: "matrix(-0.4183 -0.7587 0.8757 -0.4828 800.3093 51.6818)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B835D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7834,
    style: {
      stopColor: "#FF6447"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC751"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)",
      fill: "url(#SVGID_00000057860770220783905070000016252789545087560612_)",
      enableBackground: "new"
    },
    d: " M1003.4,60.9c67-36.9,92.9-162.4-39.4-266.4c-163.1-128.3-405,22.3-346,129.3c59,107,162.1,76.4,199.1,87.8 C854.2,22.9,936.5,97.8,1003.4,60.9z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8,
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M237.9,415.4h105.2c4.3,0,7.7,3.5,7.7,7.7v48c0,4.3-3.5,7.7-7.7,7.7H237.9c-4.3,0-7.7-3.5-7.7-7.7v-48 C230.1,418.9,233.6,415.4,237.9,415.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M256.4,435.5H323c4.3,0,7.7,3.5,7.7,7.7v7.7c0,4.3-3.5,7.7-7.7,7.7h-66.5c-4.3,0-7.7-3.5-7.7-7.7v-7.7 C248.7,439,252.2,435.5,256.4,435.5z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.05,
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)",
      fill: "#F02076",
      enableBackground: "new"
    },
    d: " M842.9,115.2h29.4c5.1,0,9.3,4.2,9.3,9.3v29.4c0,5.1-4.2,9.3-9.3,9.3h-29.4c-5.1,0-9.3-4.2-9.3-9.3v-29.4 C833.6,119.4,837.8,115.2,842.9,115.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.05,
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)",
      fill: "#F02076",
      enableBackground: "new"
    },
    d: " M559.7,229.7h29.4c5.1,0,9.3,4.2,9.3,9.3v29.4c0,5.1-4.2,9.3-9.3,9.3h-29.4c-5.1,0-9.3-4.2-9.3-9.3V239 C550.4,233.9,554.6,229.7,559.7,229.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.05,
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)",
      fill: "#F02076",
      enableBackground: "new"
    },
    d: " M574.5,119h29.4c5.1,0,9.3,4.2,9.3,9.3v29.4c0,5.1-4.2,9.3-9.3,9.3h-29.4c-5.1,0-9.3-4.2-9.3-9.3v-29.4 C565.2,123.2,569.4,119,574.5,119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)",
      fill: "#F02076",
      enableBackground: "new"
    },
    d: " M898.6,175.6H928c5.1,0,9.3,4.2,9.3,9.3v29.4c0,5.1-4.2,9.3-9.3,9.3h-29.4c-5.1,0-9.3-4.2-9.3-9.3v-29.4 C889.3,179.7,893.5,175.6,898.6,175.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)",
      fill: "#F02076",
      enableBackground: "new"
    },
    d: " M641.2,415.4h29.4c5.1,0,9.3,4.2,9.3,9.3v29.4c0,5.1-4.2,9.3-9.3,9.3h-29.4c-5.1,0-9.3-4.2-9.3-9.3v-29.4 C631.9,419.6,636.1,415.4,641.2,415.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.05,
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)",
      fill: "#F02076",
      enableBackground: "new"
    },
    d: " M898.6,235.9H928c5.1,0,9.3,4.2,9.3,9.3v29.4c0,5.1-4.2,9.3-9.3,9.3h-29.4c-5.1,0-9.3-4.2-9.3-9.3v-29.4 C889.3,240.1,893.5,235.9,898.6,235.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)",
      fill: "#F02076",
      enableBackground: "new"
    },
    d: " M960.5,115.2h29.4c5.1,0,9.3,4.2,9.3,9.3v29.4c0,5.1-4.2,9.3-9.3,9.3h-29.4c-5.1,0-9.3-4.2-9.3-9.3v-29.4 C951.2,119.4,955.4,115.2,960.5,115.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)",
      fill: "#F02076",
      enableBackground: "new"
    },
    d: " M1022.4,175.6h29.4c5.1,0,9.3,4.2,9.3,9.3v29.4c0,5.1-4.2,9.3-9.3,9.3h-29.4c-5.1,0-9.3-4.2-9.3-9.3v-29.4 C1013.1,179.7,1017.3,175.6,1022.4,175.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.05,
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)",
      fill: "#F02076",
      enableBackground: "new"
    },
    d: " M1022.4,297.8h29.4c5.1,0,9.3,4.2,9.3,9.3v29.4c0,5.1-4.2,9.3-9.3,9.3h-29.4c-5.1,0-9.3-4.2-9.3-9.3v-29.4 C1013.1,302,1017.3,297.8,1022.4,297.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)",
      fill: "#F02076",
      enableBackground: "new"
    },
    d: " M960.5,235.9h29.4c5.1,0,9.3,4.2,9.3,9.3v29.4c0,5.1-4.2,9.3-9.3,9.3h-29.4c-5.1,0-9.3-4.2-9.3-9.3v-29.4 C951.2,240.1,955.4,235.9,960.5,235.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)",
      fill: "#F02076",
      enableBackground: "new"
    },
    d: " M1022.4,115.2h29.4c5.1,0,9.3,4.2,9.3,9.3v29.4c0,5.1-4.2,9.3-9.3,9.3h-29.4c-5.1,0-9.3-4.2-9.3-9.3v-29.4 C1013.1,119.4,1017.3,115.2,1022.4,115.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)",
      fill: "#F02076",
      enableBackground: "new"
    },
    d: " M108.7,121.7c0-3.6,2.9-6.4,6.4-6.4h39.4c3.6,0,6.4,2.9,6.4,6.4V155c0,3.6-2.9,6.4-6.4,6.4h-39.4c-3.6,0-6.4-2.9-6.4-6.4V121.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)",
      fill: "#F02076",
      enableBackground: "new"
    },
    d: " M637.9,537.2c0-3.4,2.8-6.2,6.2-6.2h37.8c3.4,0,6.2,2.8,6.2,6.2v32c0,3.4-2.8,6.2-6.2,6.2h-37.8c-3.4,0-6.2-2.8-6.2-6.2V537.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)",
      fill: "#F02076",
      enableBackground: "new"
    },
    d: " M139.3,149.1c0-3.6,2.9-6.4,6.4-6.4h109.6c3.6,0,6.4,2.9,6.4,6.4v103.2c0,3.6-2.9,6.4-6.4,6.4H145.8c-3.6,0-6.4-2.9-6.4-6.4V149.1z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)",
      fill: "#F02076",
      enableBackground: "new"
    },
    d: " M659.3,446.7c0-2.3,1.9-4.2,4.2-4.2h71c2.3,0,4.2,1.9,4.2,4.2v66.8c0,2.3-1.9,4.2-4.2,4.2h-71c-2.3,0-4.2-1.9-4.2-4.2V446.7z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M841.4,118.7h143.9c4.3,0,7.7,3.5,7.7,7.7v24.8c0,4.3-3.5,7.7-7.7,7.7H841.4c-4.3,0-7.7-3.5-7.7-7.7v-24.8 C833.6,122.2,837.1,118.7,841.4,118.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8,
      clipPath: "url(#SVGID_00000047749061804726114370000003465041225202563747_)"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M672.9,511.9h135.4c4.1,0,7.4,3.3,7.4,7.4v23.5c0,4.1-3.3,7.4-7.4,7.4H672.9c-4.1,0-7.4-3.3-7.4-7.4v-23.5 C665.6,515.2,668.9,511.9,672.9,511.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCover);
export default __webpack_public_path__ + "static/media/cover.1ebe557712f8c93c18509b13486b7cae.svg";
export { ForwardRef as ReactComponent };